module.exports = __webpack_public_path__ + "public/images/slider/speaker-3-icon.1e02e6a3e91ff859ff895a6d1602162f.png";